import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";

import { SwitchDefault } from "./Switch";

export interface SwitchDefaultContainerProps {
    caseConditions: Array<EvaluableProp<boolean>>;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
}

const mapStateToProps = (state: FullFormState, ownProps: SwitchDefaultContainerProps) => {
    const allCaseConditionNegative = ownProps.caseConditions.every(x => !ownProps.processEvaluableProp(state, x));

    return {
        visible: allCaseConditionNegative,
    };
};

export const SwitchDefaultContainer = withResolvePaths(
    withViewModelSelect(withEvaluators(connect(mapStateToProps)(SwitchDefault)))
);
